import { render } from "./component-adress-house.vue?vue&type=template&id=5556685d"
import script from "./component-adress-house.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-house.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-house.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5556685d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5556685d', __exports__)) {
    api.reload('5556685d', __exports__)
  }
  
  module.hot.accept("./component-adress-house.vue?vue&type=template&id=5556685d", () => {
    api.rerender('5556685d', render)
  })

}


export default __exports__